import { FormattedMessage } from 'react-intl';
import AuthorisationWrapper from '../../../../components/utils/authorisation/authorisationWrapper';
import { CORECON_DEV_DEVICE_WRITE } from '../../../../components/utils/roleUtils';
import { DevDeviceWhitelistList } from './components/DevDeviceWhitelistList';

export const DevDeviceWhitelistHome = () => {
    return (
        <AuthorisationWrapper allowedRoles={[CORECON_DEV_DEVICE_WRITE]}>
            <span>
                <h1 key={'header'}>
                    <FormattedMessage id={'intl-msg:coreconAdminWeb.devDeviceWhitelist.moduleName'} />
                </h1>
                <DevDeviceWhitelistList />
            </span>
        </AuthorisationWrapper>
    );
};
